import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FolderOpenOutlined } from "@ant-design/icons";
import Notiflix from "notiflix";

//PROJECT IMPORTS
import { BOM } from "../../../../../services/definedMethod";
import cnt from "../../../../../services/definedConstant";

import { Table, Tooltip, Button, Form, Spin, Row, Col, Input, Modal, Divider, Space } from "antd";
import { apiConfig, labelConfig } from "../../../customer.config";
import styles from "../../../../../../src/assets/styles/styles";
import DownloadTableButtons from "../../../../../components/DownloadTableButtons";
import { showCheckerApprovalModal } from "../../../../../components/CheckerModal";
import CustomPagination from "../../../../../components/CustomPagination";

const Transactions = (props) => {
  const navigate = useNavigate();
  const {
    state,
    userData,
    currentPage,
    setCurrentPage,
    tableCount,
    setTableCount,
    totalItems,
    setTotalItems,
    onRefresh,
    transactionsList,
  } = props;
  const { session } = userData;
  const [isLoading, setIsLoading] = useState(false);

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
    },
    {
      title: "Transaction Date",
      dataIndex: "transactionDate",
    },
    {
      title: "Transaction Type",
      dataIndex: "transactionType",
    },
    {
      title: "Debit",
      dataIndex: "debit",
      render: (value) =>
        value?.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
    },
    {
      title: "Credit",
      dataIndex: "credit",
      render: (value) =>
        value?.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
    },
    {
      title: "Balance",
      dataIndex: "balance",
      render: (_, record) => {
        if (!record?.balance || record.balance === "-") return "-";

        const [code, rawAmount] = record.balance.split(" ");
        const amount = Number(rawAmount);

        if (isNaN(amount)) return record.balance;

        return `${code} ${amount.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`;
      },
    },
    {
      title: "View Receipt",
      dataIndex: "viewReceipt",
    },
    {
      title: "Actions",
      render: (_, record) => (
        <>
          <DetailTransactions
            currentCustomerObj={state}
            userData={userData}
            transactionObj={record}
          />
        </>
      ),
    },
  ];

  function handleJournalEntries() {
    navigate("/current-journal-entries", { state: state });
  }
  console.log(transactionsList);

  return (
    <>
      <Spin spinning={isLoading} size="large">
        <Row>
          <Button
            type="primary"
            shape="round"
            className="of-primaryBtnColor"
            onClick={handleJournalEntries}
          >
            <FolderOpenOutlined />
            &nbsp;{labelConfig.viewJournalEntries}
          </Button>
          {/* <DownloadTableButtons
            downloadData={transactionsList}
            columns={columns}
            fileName="Transcations List"
          /> */}
        </Row>
        <Divider orientation="left" />

        <Table pagination={false} columns={columns} dataSource={transactionsList} />
        <CustomPagination
          totalItems={totalItems}
          pageSize={Number(tableCount)}
          onPageChange={(page, offset) => onRefresh(offset)}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </Spin>
    </>
  );
};

export default Transactions;

const DetailTransactions = (props) => {
  const { currentCustomerObj, userData, transactionObj } = props;

  const { session } = userData;

  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const [inputField, setInputField] = useState([]);
  const [transactionsDetail, setTransactionsDetail] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const getDetailById = () => {
    setIsLoading(true);

    const url = `${apiConfig.savingsAccounts}/${currentCustomerObj.id}/transactions/${transactionObj.id}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setTransactionsDetail(objDetail);

        setInputField([
          {
            name: labelConfig.transactionId,
            value: objDetail?.id,
            type: "general",
          },
          {
            name: labelConfig.transactionType,
            value: objDetail?.transactionType?.value,
            type: "general",
          },
          {
            name: labelConfig.date,
            value: BOM.FormatArrayDate(objDetail?.date),
            type: "general",
          },

          {
            name: labelConfig.currency,
            value: objDetail?.currency?.displayLabel,
            type: "general",
          },
          {
            name: labelConfig.amount,
            value: objDetail.amount,
            type: "general",
          },

          {
            name: labelConfig.lienTransaction,
            value: objDetail.lienTransaction,
            type: "general",
          },
          {
            name: labelConfig.totalWithdrawalFees,
            value: objDetail?.summary?.totalWithdrawalFees,
            type: "general",
          },

          {
            name: labelConfig.paymentDetail,
            value: objDetail?.paymentDetailData?.paymentType?.name,
            type: "payment",
          },
        ]);

        setIsLoading(false);
      }
    });
  };

  const showModal = () => {
    setIsModalOpen(true);
    getDetailById();
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onUndoTransaction = (key) => {
    const formValues = {};

    formValues.transactionAmount = key?.amount;
    formValues.transactionDate = BOM.DateTime(key.date, "only-date");
    formValues.dateFormat = "dd MMMM yyyy";

    let action = "Reverse ";
    let label = "Transaction";

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",
      function () {
        // Yes
        const params = {
          command: "undo",
        };
        const url = `${apiConfig.savingsAccounts}/${currentCustomerObj.id}/transactions/${transactionObj.id}`;

        const body = {
          method: "POST",
          locale: "en",
          ...formValues,
          session,
          params,
        };

        // message.warning(
        //   "Close or Re-Open module is not ready require some works from the backend"
        // );
        // return;
        setIsLoading(true);

        BOM.FetchReqAction(
          body,
          url,
          (err, res) => {
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
              setIsLoading(false);
            } else {
              BOM.AlertMsg(cnt.SUCCESS, labelConfig.TransactionSuccessfullyReversed);

              // close modal
              setIsModalOpen(false);

              //refresh the list
              // refreshList();

              //STOP LOAD
              setIsLoading(false);
            }
          },
          {
            navigate,
            showCheckerModal: showCheckerApprovalModal,
            onCheckerApproval: (res) => {
              setIsModalOpen(false);
              setIsLoading(false);
            },
          }
        );
      },
      function () {
        // No button
      }
    );
  };

  return (
    <>
      <Tooltip title={`View Detail`}>
        <Button
          type="primary"
          icon={<FolderOpenOutlined />}
          onClick={showModal}
          shape="round"
          size="small"
          className="of-primaryBtnColor"
        />
      </Tooltip>
      <Modal
        title="Transaction Detail"
        centered
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={800}
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Form layout="vertical" form={useForm}>
            <div
              style={{
                textAlign: "right",
              }}
            >
              <Space size="small">
                {BOM.HasPermission("UNDOTRANSACTION_SAVINGSACCOUNT") && (
                  <Button
                    type="primary"
                    shape="round"
                    className="of-primaryBtnColor"
                    onClick={() => onUndoTransaction(transactionsDetail)}
                    danger={true}
                  >
                    Reverse
                  </Button>
                )}
              </Space>
            </div>
            <Row>
              <Divider orientation="left">{labelConfig.generalInfo}</Divider>
              {inputField.map(
                (item, index) =>
                  item?.type?.toLowerCase() === "general" && (
                    <Col key={index} span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item label={item.name}>
                        <Input disabled value={item.value} className="of-bold-disable-input" />
                      </Form.Item>
                    </Col>
                  )
              )}
            </Row>
          </Form>
        </Spin>
      </Modal>
    </>
  );
};
